import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { HttpFilter } from 'sol-request-angular/dist/comunicacao';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';

export class CidadeSearch{
    idIbge: number;
    nmCidade: string;
    nmEstado: string;
    limit: number;

    constructor(data:{idIbge?:number, nmCidade?:string, nmEstado?:string, limit?:number}){
        this.idIbge = data && data.idIbge;
        this.nmCidade = data && data.nmCidade;
        this.nmEstado = data && data.nmEstado;
        this.limit = data && data.limit;
    }

    getFilters():IFilter{
        let filtros:IFilter = new HttpFilter([
            new Equal('limit', 50)
        ]);

        if(this.idIbge){
            filtros.addFilter(new Equal('ibge', this.idIbge));
            this.limit = 100;
        }

        if(this.nmCidade){
            filtros.addFilter(new Equal('cidade', this.nmCidade));
            this.limit = 100;
        }            

        if(this.nmEstado){
            filtros.addFilter(new Equal('estado', this.nmEstado));
            this.limit = 100;
        }            

        return filtros;
    }
}
